import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const ADMIN_TOKEN_KEY = "hpd_admin_token";

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token) config.headers["X-Admin-Password"] = token;
  return config;
});

export const api = {
  summary: () => client.get("/hotels/summary").then((r) => r.data),
  citiesInState: (state) =>
    client.get(`/hotels/state/${encodeURIComponent(state)}/cities`).then((r) => r.data),
  listHotels: (params = {}) => client.get("/hotels", { params }).then((r) => r.data),
  topHotels: (metric, limit = 10) =>
    client.get("/hotels/top", { params: { metric, limit } }).then((r) => r.data),
  getHotel: (id) => client.get(`/hotels/${id}`).then((r) => r.data),
  createHotel: (body) => client.post("/hotels", body).then((r) => r.data),
  updateHotel: (id, body) => client.put(`/hotels/${id}`, body).then((r) => r.data),
  deleteHotel: (id) => client.delete(`/hotels/${id}`).then((r) => r.data),
  uploadImage: (file) => {
    const form = new FormData();
    form.append("file", file);
    return client.post("/uploads", form, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  login: (password) => axios.post(`${API}/admin/login`, { password }).then((r) => r.data),
  getDisabledStates: () => client.get("/states/disabled").then((r) => r.data),
  toggleState: (state, disabled) => client.post("/states/toggle", { state, disabled }).then((r) => r.data),
};

export const fileUrl = (path) => (path?.startsWith("http") ? path : `${API}/files/${path}`);
